module.exports = __webpack_public_path__ + "img/Icon awesome-sticky-note.ff4f3303.svg";